import React from 'react'
import { useContext } from './Context'
import isEmpty from 'lodash/isEmpty'
import { ShowIf } from '@ztechapps/webui.util'
import { ChatAttachments } from './ChatAttachments'
import { collectChatAttachments } from './collectChatAttachments'

export const AllChatAttachments = () => {
  const context = useContext()
  const { messages } = context

  const allAttachments = React.useMemo(() => collectChatAttachments(messages), [messages])

  return (
    <ShowIf condition={!isEmpty(allAttachments)}>
      <hr />
      <ChatAttachments attachments={allAttachments} />
    </ShowIf>
  )
}
